var _svg;

import React from 'react';
import styled from 'styled-components';
import Box from '../Box/Box';
var LogoWrap = styled(Box).withConfig({
  displayName: "Logo__LogoWrap",
  componentId: "sc-4cou51-0"
})(["svg{width:auto;height:100%;}"]);

function Logo(props) {
  return /*#__PURE__*/React.createElement(LogoWrap, props, _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1002 223",
    role: "img"
  }, /*#__PURE__*/React.createElement("title", null, "Stash Logo"), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M64.08.78C27.56.78 1 31.27 1 63.69a63 63 0 0063.08 63.28h77.22c16.59 0 32.49 13.39 32.49 31.66 0 18.26-14.23 33.2-32.49 33.2H4.27v30.41h142.45c36.66 0 63.84-28.35 63.84-63.64 0-33.88-27.9-62.33-63.84-62.33H67.69A32.42 32.42 0 0135.2 63.66c0-18.06 15.02-32.22 32.49-32.25h194.96v190.82h34.17V31.41h86.73V.77L64.08.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M966.23.76v95.53H831.64V.76h-34.77v221.46h34.77v-95.3h134.59v95.3H1001V.76h-34.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M491.51 191.6h-66.4v30.64h66.4V191.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M703.66 96.27h-79.03a32.42 32.42 0 01-32.49-32.61c0-18.06 15.02-32.22 32.49-32.25h127.09V.77l-130.7.01c-36.53 0-63.08 30.49-63.08 62.91a63 63 0 0063.08 63.28h77.21c16.59 0 32.5 13.39 32.5 31.66 0 18.26-14.23 33.2-32.5 33.2H563.3L471.47.77H444.3L336.93 222.24h34.87l86.12-175.38 84.57 175.38h161.18c36.66 0 63.83-28.35 63.83-63.64 0-33.88-27.9-62.33-63.84-62.33z"
  }))));
}

Logo.defaultProps = {
  height: '100%',
  color: 'fillLogo'
};
export default Logo;